import CustomerRecipientWidget from '../../../../orders/customer-recipient-widget/component';
import sectionStyle from '../orders-sidebar-section.module.less';
import style from './customer-section-content.module.css';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @param {string} props.salesOrderId
 * @returns {JSX.Element}
 */
export const CustomerSectionContent = ({ fulfillmentPlanId, salesOrderId }) => {
  return (
    <div className={sectionStyle['order-sidebar-section-default-padding']}>
      <CustomerRecipientWidget
        editLinkContainerClassName={style['edit-link-container']}
        headerClassName={style['customer-recipient-widget-header']}
        salesOrderId={salesOrderId}
        selectedFulfillmentPlanId={fulfillmentPlanId}
      />
    </div>
  );
};
